
import { computed, ComputedRef, defineComponent } from 'vue';
import siteContextService from '@/b2c/shared/site-context.service';
import LogoutLink from '@/shared/navigation/LogoutLink.vue';
import authStore from '@/shared/auth/auth.store';
import { B2CFooterViewModel, B2CContentPageContent } from '@/types/B2CcontentServerContract';
import PageFooterAccordion from '@/b2c/layout/footer/PageFooterAccordion.vue';
import ScrollToTopButton from '@/shared/navigation/ScrollToTopButton.vue';
import TrustpilotMiniWidget from '@/shared/content/blocks/trustpilot/TrustpilotMiniWidget.vue';
import pageStore from '@/shared/content/page.store';

export default defineComponent({
    name: 'PageFooter',
    components: { ScrollToTopButton, PageFooterAccordion, LogoutLink, TrustpilotMiniWidget },
    setup() {
        const footer: ComputedRef<B2CFooterViewModel> = computed(() => {
            return (pageStore.content as B2CContentPageContent).b2CFooter ?? siteContextService.footer;
        });

        const shouldShowLogout: ComputedRef<boolean> = computed(() => {
            return authStore.isSignedIn;
        });

        const hasFooterTiles: ComputedRef<boolean> = computed(() => {
            return footer.value.tiles?.length > 0;
        });

        const isLastColumn = (idx: number): boolean => {
            return footer.value.columns?.length === idx + 1 ?? false;
        };

        return {
            footer,
            hasFooterTiles,
            isLastColumn,
            shouldShowLogout,
        };
    },
});
